package br.com.texeratx.boardgametimeapp.ui.screens.matches.model

data class MatchListItemUI(
    val id: Long,
    val date: String,
    val duration: Int,
    val game: MatchGameUI,
    val players: List<MatchPlayerUI>,
    val expansionIds: List<Long>
) {
    // ✅ Heurística: se algum player não tem id válido, ou não tem pontuação carregada, consideramos stub
    val isStub: Boolean
        get() = players.isEmpty() || players.any { it.id <= 0L }
}

data class MatchGameUI(
    val id: Long,
    val name: String,
    val imageUrl: String?
)

data class MatchPlayerUI(
    val id: Long,
    val name: String,
    val nickname: String?,
    val imageUrl: String?,
    val points: Double
)

